import { Box, HStack, Icon, Stack, Text } from "@chakra-ui/react";
import {
  CrashType,
  RiskFactor,
  riskFactorColors,
  Score,
  ScoreEntry,
} from "@keita/lanepatrol-sdk";
import { BicycleIcon, CarIcon, WalkIcon } from "../../shared/views/icons";
import { IconType } from "react-icons/lib";

export const HlaScoreView = ({ score }: { score?: Score }) => {
  return (
    <Stack
      alignItems="center"
      fontWeight={"bold"}
      fontSize="sm"
      textAlign="center"
    >
      <Stack gap={1} alignItems="center">
        <Text textTransform={"uppercase"} textStyle={"label"}>
          High-level score
        </Text>

        <HlaScoreEntryView score={score?.global} />
      </Stack>
      <HStack gap={4}>
        {Object.values(CrashType).map((crashType, index) => (
          <Stack alignItems="center" key={index} gap={1}>
            <Box fontSize="md">{icons[crashType]}</Box>
            <HlaScoreEntryView score={score?.[crashType]} />
          </Stack>
        ))}
      </HStack>
    </Stack>
  );
};

export const HlaScoreEntryView = ({ score }: { score?: ScoreEntry }) => {
  return (
    <Box fontWeight={"bold"} fontSize="sm" color={getColor(score?.riskFactor)}>
      {score ? score.value.toFixed(2) : "-"}
    </Box>
  );
};

const getColor = (riskFactor?: RiskFactor) =>
  riskFactor ? riskFactorColors[riskFactor] : defaultColor;

const defaultColor = "#DDDDDD";

const wrapIcon = (icon?: IconType) => {
  return (
    <HStack position="relative" boxSize={"30px"} justifyContent={"center"}>
      {icon ? (
        <>
          <Icon
            fontSize={"sm"}
            position="absolute"
            top={0}
            left={0}
            as={BicycleIcon}
          />
          <Icon
            fontSize={"lg"}
            position="absolute"
            right={0}
            bottom={0}
            as={icon}
          />
        </>
      ) : (
        <Icon fontSize={"xl"} as={BicycleIcon} />
      )}
    </HStack>
  );
};

const icons = {
  [CrashType.vehicleToBicycle]: wrapIcon(CarIcon),
  [CrashType.bicycleToBicycle]: wrapIcon(BicycleIcon),
  [CrashType.bicycleToPedestrian]: wrapIcon(WalkIcon),
  [CrashType.singleBicycle]: wrapIcon(),
};
